<template>
  <div :class="isMobile ? 'home-container-mobile' : 'home-container'">
    <div class="IndexMain">
      <IndexBanner/>
      <TotalLine/>
      <ProductTabs/>
      <SolutionIndex/>
      <NewsSection/>
      <!--      <IndexOne />-->
      <!--      <IndexThree />-->
      <!--      合作伙伴-->
      <!--      <PartnerShip />-->
    </div>
  </div>
</template>

<script>
import IndexBanner from './common/IndexBanner.vue';
import TotalLine from './common/TotalLine.vue';
import SolutionIndex from './common/SolutionIndex.vue';
import ProductTabs from './product/ProductTabs.vue';
import NewsSection from './news/NewsSection.vue';
// import IndexOne from './common/IndexOne.vue';
// import IndexThree from './common/IndexThree.vue';
// import PartnerShip from './common/PartnerShip.vue';

// import { getSetting } from '@/api/request';

export default {
  name: 'HomeView',
  components: {
    IndexBanner,
    TotalLine,
    SolutionIndex,
    ProductTabs,
    NewsSection
    // IndexOne,
    // IndexThree,
    // PartnerShip,
  },
  data() {
    return {
      isMobile: false
    };
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
  }
};
</script>

<style scoped>
.home-container, .home-container-mobile {
  background: white;
}
</style>